import { processTemplatesTranslation } from '@/assets/locales/views/admin/processTemplates/processTemplates.translation.pl.ts';
import { analysisRemarksViewTranslation } from '@/assets/locales/views/analysisRemarks/analysisRemarks.translation.pl.ts';
import { candidateDetailsTranslation } from '@/assets/locales/views/candidates/details/candidateDetails.translation.pl.ts';
import { experienceCompaniesTranslation } from '@/assets/locales/views/experienceCompanies/experienceCompanies.translation.pl.ts';
import { interviewSimulationsTranslation } from '@/assets/locales/views/interviewSimulations/interviewSimulations.translation.pl.ts';
import { maintenanceTranslation } from '@/assets/locales/views/maintenance/maintenance.translation.pl.ts';
import { meetingsViewTranslation } from '@/assets/locales/views/meetings/meetings.translation.pl.ts';
import { processesTranslation } from '@/assets/locales/views/processes/processes.translation.pl.ts';
import { statisticsTranslation } from '@/assets/locales/views/statistics/statistics.translation.pl.ts';
import { ViewsTranslation } from '@/assets/locales/views/views.translation.en.ts';

export const viewsTranslation: ViewsTranslation = {
  analysisRemarks: analysisRemarksViewTranslation,
  candidates: candidateDetailsTranslation,
  experienceCompanies: experienceCompaniesTranslation,
  interviewSimulations: interviewSimulationsTranslation,
  maintenance: maintenanceTranslation,
  meetings: meetingsViewTranslation,
  processes: processesTranslation,
  processTemplates: processTemplatesTranslation,
  statistics: statisticsTranslation,
};
